import { render, staticRenderFns } from "./ChangeShareDocumentDialog.vue?vue&type=template&id=22ce4939&scoped=true"
import script from "./ChangeShareDocumentDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeShareDocumentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce4939",
  null
  
)

export default component.exports